<template>
  <ul class="nav flex-lg-column statusButton" :class="customClass">
    <loading
      :is-full-page="true"
      class="fullPage"
      :active="loadingBtnState === 'publish' || loadingBtnState === 'reject' || loadingBtnState === 'submitForApproval' || loadingBtnState === 'recall'"
    />

    <li v-if="makeVisible && !pricingPage" class="nav-item">
      <a
        class="nav-link active"
        :data-toggle="dataTargetCreateUpdate || dataTargetCreate ? 'modal' : null"
        :data-target="dataTargetCreateUpdate || dataTargetCreate"
        @click="createNewEntity()"
      >
        <i class="fa fa-plus" />
        <span class="text">Ekle</span>
      </a>
    </li>

    <li v-if="makeUpdateVisible" class="nav-item">
      <a
        :class="updatePermission ? '' : 'disabled'"
        class="nav-link"
        :data-toggle="dataTargetCreateUpdate ? 'modal' : null"
        :data-target="dataTargetCreateUpdate"
        @click="[dataTargetCreateUpdate === null ? updateSelectedEntity() : null, updateEvent()]"
      >
        <i class="fa fa-sync-alt" />
        <span class="text">Güncelle</span>
      </a>
    </li>
    <li v-if="pricingPage" class="nav-item">
      <a :class="saveEnabled ? '' : 'disabled'" class="nav-link" @click="$emit('saveChanges')">
        <i class="fa fa-save" />
        <span class="text">Kaydet</span>
      </a>
    </li>
    <li class="nav-item" @click="submitForApproval()">
      <b-link :class="[submitForApprovalPermission ? '' : 'disabled', loadingBtnState === 'submitForApproval' ? 'disabled' : null]" class="nav-link">
        <i class="fa fa-check" />
        <span class="text">Onaya Gönder</span>
      </b-link>
    </li>
    <li class="nav-item" @click="publish()">
      <b-link :class="[publishPermission ? '' : 'disabled', loadingBtnState === 'publish' ? 'disabled' : null]" class="nav-link">
        <i class="fa fa-paper-plane" />
        <span class="text">Onayla ve Yayınla</span>
      </b-link>
    </li>
    <li class="nav-item" @click="reject()">
      <b-link :class="[rejectPermission ? '' : 'disabled', loadingBtnState === 'reject' ? 'disabled' : null]" class="nav-link">
        <i class="fa fa-ban" />
        <span class="text">Reddet</span>
      </b-link>
    </li>
    <li class="nav-item" @click="recall()">
      <b-link :class="[recallPermission ? '' : 'disabled', loadingBtnState === 'recall' ? 'disabled' : null]" class="nav-link">
        <i class="fas fa-history" />
        <span class="text">İşlemi Geri Al</span>
      </b-link>
    </li>
    <li class="nav-item" @click="cancel()">
      <b-link :class="[cancelPermission ? '' : 'disabled', loadingBtnState === 'cancel' ? 'disabled' : null]" class="nav-link">
        <i class="fas fa-times" />
        <span class="text">İşlemi İptal Et</span>
      </b-link>
    </li>
    <li v-if="makeDeleteVisible" class="nav-item">
      <a
        :class="deletePermission || deleteDraftPermission ? '' : 'disabled'"
        class="nav-link"
        :data-toggle="dataTargetDelete ? 'modal' : null"
        :data-target="dataTargetDelete"
      >
        <i class="fa fa-trash-alt" />
        <span class="text">Sil</span>
      </a>
    </li>
    <li v-if="customRouteButton" class="nav-item" @click="customButton()">
      <b-link class="nav-link">
        <i class="fas fa-users-cog" />
        <span class="text">Yetkileri Düzenle</span>
      </b-link>
    </li>
    <li v-if="kkyButton" class="nav-item" data-toggle="modal" :data-target="kkyModalDataTarget" @click="customButton()">
      <b-link class="nav-link">
        <i class="fas fa-exchange-alt" />
        <span class="text">KKY'den Aktar</span>
      </b-link>
    </li>
    <li v-if="excelExportButton" class="nav-item" @click="excelExport()">
      <b-link class="nav-link">
        <i class="fas fa-file-download" />
        <span class="text">Excel Olarak İndir</span>
      </b-link>
    </li>
  </ul>
</template>

<script>
import Loading from "vue-loading-overlay";

export default {
  name: "WorkFlowControlBox",
  components: {
    Loading,
  },
  props: {
    deletePermission: {
      type: Boolean,
      default: false,
    },
    deleteDraftPermission: {
      type: Boolean,
      default: false,
    },
    updatePermission: {
      type: Boolean,
      default: false,
    },
    publishPermission: {
      type: Boolean,
      default: false,
    },
    rejectPermission: {
      type: Boolean,
      default: false,
    },
    recallPermission: {
      type: Boolean,
      default: false,
    },
    cancelPermission: {
      type: Boolean,
      default: false,
    },
    submitForApprovalPermission: {
      type: Boolean,
      default: false,
    },
    loadingBtnState: {
      type: String,
      default: "",
    },
    isCreateModal: {
      type: Boolean,
      default: false,
    },
    dataTargetCreateUpdate: {
      type: String,
      default: null,
    },
    dataTargetCreate: {
      type: String,
      default: null,
    },
    dataTargetDelete: {
      type: String,
      default: "#deleteModal",
    },
    customRouteButton: {
      type: Boolean,
      default: false,
    },
    kkyButton: {
      type: Boolean,
      default: false,
    },
    kkyModalDataTarget: {
      type: String,
      default: "",
    },
    makeVisible: {
      type: Boolean,
      default: true,
    },
    makeDeleteVisible: {
      type: Boolean,
      default: true,
    },
    makeUpdateVisible: {
      type: Boolean,
      default: true,
    },
    excelExportButton: {
      type: Boolean,
      default: false,
    },
    customClass: {
      type: String,
      default: null,
    },
    saveEnabled: {
      type: Boolean,
      default: false,
    },
    pricingPage: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    submitForApproval() {
      this.$emit("submitForApproval");
    },
    reject() {
      this.$emit("reject");
    },
    publish() {
      this.$emit("publish");
    },
    recall() {
      this.$emit("recall");
    },
    cancel() {
      this.$emit("cancel");
    },
    updateSelectedEntity() {
      this.$emit("updateSelectedEntity", this.updatePermission);
    },
    createNewEntity() {
      this.$emit("createNewEntity");
    },
    updateEvent() {
      this.$emit("updateEvent");
    },
    customButton() {
      this.$emit("customButton");
    },
    excelExport() {
      // Todo : tablo excel olarak yazdırılacak
    },
  },
};
</script>

<style scoped>
.fa-file-download {
  color: #233053;
}
</style>
